import ReactDOM from 'react-dom/client';
import { initGA } from '@/analytics';
import Root from './Root';
import { detectIsMobileDevice } from './hooks/useIsMobileDevice';
import './globals.css';

initGA();

document.documentElement.setAttribute('data-device', detectIsMobileDevice() ? 'mobile' : 'desktop');

ReactDOM.createRoot(document.getElementById('root')!).render(<Root />);
